import english from './english';
import french from './french';

export default {
  fr: french,
  en: english,
};
